import { createAsyncThunk } from '@reduxjs/toolkit';

import * as SitesApi from '@sophocles/api/sites';

export const loadSites = createAsyncThunk('sites/load', async (queryParams, { rejectWithValue }) => {
  try {
    const data = await SitesApi.fetchSites(queryParams);
    return data;
  } catch (e) {
    return rejectWithValue(e.response.data);
  }
});
